import { createContext } from "react";

const SidebarContext = createContext();
SidebarContext.displayName = "SidebarContext";

export default SidebarContext;
